import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from '../environments/environment';
import { ROUTES } from './app.routes';
import { httpErrorInterceptor } from './shared/interceptor/http-error.interceptor';
import { httpHeaderInterceptor } from './shared/interceptor/http-header.interceptor';
import GCMPreset from './app.preset';
import { provideAbpCore, withOptions } from '@abp/ng.core';
import { provideAbpOAuth } from '@abp/ng.oauth';
import { registerLocale } from './app.register.locale';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule,LicenseManager } from 'ag-grid-enterprise';
import { CustomErrorHandler } from './services/custom-error-handler.service';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-088555}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Canviz}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{GIP_GCM}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{GIP_GCM}_need_to_be_licensed___{GIP_GCM}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{21_May_2026}____[v3]_[01]_MTc3OTMxODAwMDAwMA==60aca46d303daaabdb90ce924fd16b6d");

export const BACKEND_URL = new InjectionToken<string>('BACKEND_URL');
let baseUrl = environment.apis.default.url;
if (baseUrl.endsWith('/')) {
  baseUrl = baseUrl.substring(0, baseUrl.length - 1);
}

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    ConfirmationService,
    DialogService,
    {
      provide: BACKEND_URL,
      useValue: baseUrl,
    },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(ROUTES),

    provideHttpClient(withInterceptors([httpHeaderInterceptor, httpErrorInterceptor])),

    provideAbpCore(
      withOptions({
        environment,
        registerLocaleFn: registerLocale,
      })
    ),

    provideAbpOAuth(),

    //PrimeNG v18
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: GCMPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
  ],
};
